import { LogIn, LogOut } from "lucide-react";
import { useAuth } from "../auth/useAuth";
import { useI18n } from "../i18n";

function initials(name?: string | null) {
  if (!name) return "P";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function ProfileHeader() {
  const { user, loading, signIn, signOut } = useAuth();
  const { t } = useI18n();

  return (
    <div className="profile-header">
      <div className="avatar">
        {user?.photoURL ? <img src={user.photoURL} alt="" /> : initials(user?.displayName)}
      </div>
      <div className="details">
        <div className="name">{user?.displayName ?? t("auth.guest")}</div>
        <div className="email">{loading ? t("common.loading") : user?.email ?? t("auth.fullAccess")}</div>
      </div>
      <button
        aria-label={user ? t("common.signOut") : t("common.signIn")}
        type="button"
        onClick={() => (user ? signOut() : signIn())}
      >
        {user ? <LogOut size={17} /> : <LogIn size={17} />}
      </button>
    </div>
  );
}
